<hs-form-field class="w-full">
  <hs-form-label>{{ accountHolderLabel }}</hs-form-label>
  <input
    hsInput
    [value]="accountHolder()"
    (change)="updateProperty('accountHolder', $any($event.target).value)"
  />
</hs-form-field>

<kfm-iban-input-field [ibanDetail]="ibanDetail"></kfm-iban-input-field>

<hs-form-field class="w-full">
  <hs-form-label>{{ bicLabel }}</hs-form-label>
  <input
    hsInput
    [value]="swiftCode()"
    (change)="updateProperty('swiftCode', $any($event.target).value)"
  />
</hs-form-field>

<br />

<div class="flex flex-row gap-2">
  <div class="w-1/2">
    <hs-form-field class="w-full">
      <hs-form-label>{{ accountNumberLabel }}</hs-form-label>
      <input
        hsInput
        [value]="accountNumber()"
        (change)="updateProperty('accountNumber', $any($event.target).value)"
      />
    </hs-form-field>
  </div>
  <div class="w-1/2">
    <hs-form-field class="w-full">
      <hs-form-label>{{ blzLabel }}</hs-form-label>
      <input
        hsInput
        [value]="bankCodeNumber()"
        (change)="updateProperty('bankCodeNumber', $any($event.target).value)"
      />
    </hs-form-field>
  </div>
</div>

<hs-form-field class="w-full">
  <hs-form-label>{{ bankNameLabel }}</hs-form-label>
  <input
    hsInput
    [value]="bankName()"
    (change)="updateProperty('bankName', $any($event.target).value)"
  />
</hs-form-field>

<br />

<!-- Mandate reference fields - only show for non-tenant contacts -->
<ng-container *ngIf="showMandateReferenceFields()">
  <hs-form-field class="w-full">
    <hs-form-label>{{ mandateReferenceNumberLabel }}</hs-form-label>
    <input
      hsInput
      [value]="mandateReferenceNumber()"
      (change)="
        updateProperty('mandateReferenceNumber', $any($event.target).value)
      "
    />
  </hs-form-field>

  <hs-form-field>
    <hs-form-label>{{ mandateReferenceDateLabel }}</hs-form-label>
    <hs-date-picker
      [value]="mandateReferenceDate()"
      (input)="onMandateReferenceDateChanged($any($event.target).value)"
    />
  </hs-form-field>
</ng-container>
